import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import FireAgencyReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/fire-agency.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(FireAgencyReducer, defaultState, asyncActions);
};

type IFireAgencyContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const FireAgencyContext = createContext<Partial<IFireAgencyContext>>({
  state: defaultState,
}) as React.Context<IFireAgencyContext>;

const FireAgencyProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <FireAgencyContext.Provider value={{ ...reducer }}>
      {children}
    </FireAgencyContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useFireAgencyContext = () => useContext(FireAgencyContext);

export type IUseFireAgencyContext = ReturnType<typeof useFireAgencyContext>;

export { FireAgencyContext, FireAgencyProvider };
